<template>
  <div
    class="apio-button arrow"
    :class="[buttonTypeClass, buttonSizeClass, buttonDirectionClass]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "apio-button-arrow",
  props: {
    buttonType: {
      type: String,
      default: "arrow",
    },
    buttonSize: {
      type: String,
      default: "small",
    },
    direction: {
      type: String,
      default: "left",
    },
  },
  computed: {
    buttonTypeClass() {
      return this.buttonType ? `apio-button--${this.buttonType}` : "";
    },
    buttonSizeClass() {
      return this.buttonSize
        ? `apio-button--${this.buttonType}-${this.buttonSize}`
        : "";
    },
    buttonDirectionClass() {
      let arrowDirection = ''
      if(this.direction) { 
        arrowDirection = `arrow-${this.direction}`
      }
  
      return arrowDirection
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow {
  background-position: center;
  padding: 8px;
  border: 1px solid var(--apio-shade-4) !important;
}
</style>